const YouTubeSvg = ({
  height = 14,
  width = 14,
  viewBox = '0 0 14 14',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M13.7072 3.60894C13.6281 3.31102 13.4721 3.03911 13.2549 2.82043C13.0376 2.60175 12.7667 2.44399 12.4693 2.36294C11.3779 2.06836 7 2.06836 7 2.06836C7 2.06836 2.62208 2.06836 1.53008 2.36294C1.23282 2.44413 0.962088 2.60195 0.744962 2.82062C0.527836 3.03928 0.371928 3.31112 0.292833 3.60894C0 4.70794 0 7.00044 0 7.00044C0 7.00044 0 9.29294 0.292833 10.3919C0.371925 10.6899 0.527902 10.9618 0.745145 11.1805C0.962388 11.3991 1.23327 11.5569 1.53067 11.6379C2.62208 11.9325 7 11.9325 7 11.9325C7 11.9325 11.3779 11.9325 12.4699 11.6379C12.7673 11.5569 13.0383 11.3992 13.2555 11.1805C13.4728 10.9618 13.6287 10.6899 13.7078 10.3919C14 9.29294 14 7.00044 14 7.00044C14 7.00044 14 4.70794 13.7072 3.60894ZM5.56792 9.08178V4.91911L9.22717 7.00044L5.56792 9.08178Z"
        fill="white"
      />
    </svg>
  );
};

export default YouTubeSvg;
